import ArrowButton from "@/components/molecules/arrowButton"

const Description = ({
    description
}) => {
  return (
    <div className="order-2 lg:order-1 flex-1 basis-0 lg:max-w-[290px]">
      <div className="relative w-full lg:aspect-[3/4] flex flex-col justify-center lg:justify-between">
        <div className="w-full text-bodyMobile md:text-bodyDesktop text-umber font-chivoMono">
          <p>{description}</p>
        </div>
        <ArrowButton name="About Us" link="/about" className="mt-smallMobile mx-auto lg:mx-0 lg:mt-0" />
      </div>
    </div>
  )
}

export default Description
